/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const loadingSignInConfig = {
  GetPageLoading: {
    image: 'https://i.ibb.co/R4nz5J3/bli-logo.png',
    titleNormalText: 'Loading',
    titleBoldText: '...',
    description: 'This might take few seconds, Please wait !',
  },
  signInUser: {
    image: 'https://i.ibb.co/R4nz5J3/bli-logo.png',
    titleNormalText: 'Signing into',
    titleBoldText: 'your account...',
    description: 'This might take few seconds, Please wait !',
  },
};
